import axios from '@/libs/api.request'
// 项目初览列表
export const getPreviewList = data => {
  return axios.request({
    url: '/pre/project/preliminary/list',
    data,
    method: 'POST'
  })
}
// 项目初览 对应 详情
export const getPreviewItemDetail = data => {
  return axios.request({
    url: '/pre/project/preliminary/detail',
    data,
    method: 'POST'
  })
}
// 项目初览 对应 学校列表
export const getPreviewItemList = data => {
  return axios.request({
    url: '/pre/project/preliminary/choose/project/list',
    data,
    method: 'POST'
  })
}
// 项目初览 对应 有意向学校列表
export const getPreviewItemPurposeList = data => {
  return axios.request({
    url: '/pre/project/preliminary/choose/project/purpose/list',
    data,
    method: 'POST'
  })
}
// 是否有申请意向
export const getItemPurposeModify = data => {
  return axios.request({
    url: '/pre/project/purpose/modify',
    data,
    method: 'POST'
  })
}
// 项目初览 对应 项目反馈
export const subItemFeedbackModify = data => {
  return axios.request({
    url: '/pre/project/purpose/feedback',
    data,
    method: 'POST'
  })
}
// 项目初览 对应 添加意向反馈
export const subtPreviewItemAddFeedback = data => {
  return axios.request({
    url: '/pre/project/preliminary/save/feedback',
    data,
    method: 'POST'
  })
}
// 查询意见反馈
export const getPreviewItemAddFeedback = data => {
  return axios.request({
    url: '/pre/project/preliminary/feedback/detail',
    data,
    method: 'POST'
  })
}
// 选校方案 - 列表
export const getSchemeList = data => {
  return axios.request({
    url: '/pre/project/scheme/list',
    data,
    method: 'POST'
  })
}
// 选校方案 对应  详情
export const getSchemeItemDetail = data => {
  return axios.request({
    url: '/pre/project/scheme/detail',
    data,
    method: 'POST'
  })
}
// 选校方案 对应 学校列表
export const getSchemeItemList = data => {
  return axios.request({
    url: '/pre/project/scheme/choose/project/list',
    data,
    method: 'POST'
  })
}
// 选校方案 对应 有意向学校列表
export const getSchemeItemPurposeList = data => {
  return axios.request({
    url: '/pre/project/scheme/choose/project/purpose/list',
    data,
    method: 'POST'
  })
}
// 选校方案 对应 添加意向反馈
export const subSchemeItemAddFeedback = data => {
  return axios.request({
    url: '/pre/project/scheme/save/feedback',
    data,
    method: 'POST'
  })
}
// 选校方案 对应 查询意向反馈
export const getSchemeItemAddFeedback = data => {
  return axios.request({
    url: '/pre/project/scheme/feedback/detail',
    data,
    method: 'POST'
  })
}
